<template>
    <Layout>
        <div slot="main" class="home-bg">
            <div class="banner-container">
                <img :src="banner" alt="">
                <!-- <strong>{{bannerTitle}}</strong> -->
            </div>
            <div class="sub-page">
                <div class="main_section">
                    <div class="section_item intro-block">
                        <h2 class="title">{{introTitle}}</h2>
                        <div class="center" :style="{flexDirection: introImageIsRight?'row':'row-reverse'}">
                            <div class="gen-content-half">
                                <div class="editor-gen" v-html="introContent"></div>
                            </div>
                            <div class="introduction_img" v-if="introImgs.length">
                                <swiper :options="halfPhotoOption"  v-if="introImgs.length >1" class="swiper-no-swiping">
                                    <swiper-slide v-for="(item,index) in introImgs" :key="index">
                                        <img :src="item"/>
                                    </swiper-slide>
                                    <div class="swiper-pagination" slot="pagination"></div>
                                    <div class="swiper-button-prev" slot="button-prev"></div>
                                    <div class="swiper-button-next" slot="button-next"> </div>
                                </swiper>
                                <div v-if="introImgs.length === 1"><img :src="introImgs[0]"/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import ajax from '@/utils/ajax';
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';

export default {
    name: 'aboutIntroPreview',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            banner: null,
            bannerTitle: '',
            lang: getLang(),
            halfPhotoOption: {
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                loop: true,
            },
            introTitle: '',
            introIndex: 0,
            introContent: '',
            introImgs: [],
        };
    },
    mounted() {
        const self = this;
        ajax.get('/web/common/navigate_list.json', { documentUrl: 'about' }).then((result) => {
            this.banner = result.data.parentNavigate.navigateWebImg;
            this.bannerTitle = this.isCn ? result.data.parentNavigate.navigateCnName : result.data.parentNavigate.navigateEnName;
        }).catch(() => {});
        const getMessage = (event) => {
            console.log(event);
            if (!event.data.aboutIntroPage) return;
            const result = event.data;
            self.introImgs = result.data.images.split(',');
            self.introContent = self.isCn ? result.data.cnContent : result.data.enContent;
            self.introTitle = self.isCn ? result.data.cnName : result.data.enName;
            this.introImageIsRight = result.data.isRight;
            window.removeEventListener('message', getMessage);
        };
        window.addEventListener('message', getMessage, false);
        if (window.opener) {
            window.opener.postMessage('aboutIntroReady');
        }
    },
};
</script>
<style lang="less" scoped>
    .banner-container {
        width: 100%;
        height: 400px;
        position: relative;
        img{
            width: 100%;
            height: 100%;
        }
        strong{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 32px;
            color: #fff;
            font-weight: 600;
        }
    }
    .main_section{
        border-top: 8px solid #F8FAF9;
        width: 100%;
        height: auto;
        .section_item{
            width: 100%;
            height: auto;
            &:nth-child(even){
                background:rgba(248,250,249,1);
            }
            .title{
                padding-top: 40px;
                font-size: 20px;
                font-weight: 600;
                color: rgba(74,74,74,1);
                line-height: 20px;
                text-align: center;
                position: relative;
                &::after{
                    content:"";
                    width:44px;
                    height:4px;
                    background:rgba(199,31,75,1);
                    position: absolute;
                    bottom: -12px;
                    left: 50%;
                    margin-left: -22px;
                }
            }
            .introduction_img{
                width: 350px;
                img{
                    width: 350px;
                    height: 350px;
                }
                .swiper-button-prev{
                    width:32px;
                    height:32px;
                    margin-top: -16px;
                    outline: none;
                    background-image: url('../../style/index_swiper_button_prev.png');
                    background-size: 100% 100%;
                }
                .swiper-button-next{
                    width:32px;
                    height:32px;
                    margin-top: -16px;
                    outline: none;
                    background-image: url('../../style/index_swiper_button_next.png');
                    background-size: 100% 100%;
                }
            }
        }
    }
    .gen-content-half {
        flex: 0 0 580px;
    }
    .center {
        margin: 0 auto;
        width: 960px;
        padding: 24px 0 40px;
        display: flex;
        justify-content: space-between;
    }
</style>
